var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-modal__backdrop"},[_c('div',{staticClass:"error-modal"},[_c('icon',{attrs:{"name":"error"}}),_c('span',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }